function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M28.52,4.14A9.33,9.33,0,0,0,16,5.07,9.32,9.32,0,0,0,3.48,4.14a9.35,9.35,0,0,0-.65,13.68L13.67,28.87a3.25,3.25,0,0,0,4.66,0l10.84-11A9.36,9.36,0,0,0,28.52,4.14Zm-1.46,11.6-10.85,11a.25.25,0,0,1-.42,0l-10.85-11a6.38,6.38,0,0,1,.45-9.32,6.27,6.27,0,0,1,8.45.65L16,9.27l2.16-2.2a6.27,6.27,0,0,1,8.45-.66,6.41,6.41,0,0,1,.45,9.33Z",
  transform: "translate(-0.17 -2.14)"
});

var SvgHeartThin = function SvgHeartThin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    viewBox: "0 0 31.67 27.72",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeartThin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/heart-thin.aba26065.svg";
export { ForwardRef as ReactComponent };